import React from "react";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

const Barchart = prop => {
  const randomColor = () => `hsl(${Math.floor(Math.random() * 360)}, 70%, 50%)`;

  return (
    <ResponsiveContainer width="100%" height={290}>
      <ComposedChart
        data={prop.dataBar}
        margin={{ top: 15, right: 30, left: 10, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="name"
          tickLine={false}
          //   axisLine={false}
        />
        <YAxis />

        {prop.order === "R1" &&
          <Tooltip formatter={value => [`${value} เรื่อง`, "จำนวน"]} />}

        {prop.order === "R2" &&
          <Tooltip
            formatter={(value, name) => [`${value} เรื่อง`, name.toUpperCase()]}
          />}

        {prop.order === "R3" &&
          <Tooltip formatter={value => [`${value} `, "ร้อยละ"]} />}

        {prop.order === "R4" &&
          <Tooltip formatter={value => [`${value} `, "ร้อยละ"]} />}

        {prop.order === "R5" &&
          <Tooltip formatter={value => [`${value} เรื่อง`, "จำนวน"]} />}

        {prop.order === "I1" &&
          <Tooltip formatter={value => [`${value} `, "ร้อยละ"]} />}

        {prop.order === "I2" &&
          <Tooltip formatter={value => [`${value} `, "ร้อยละ"]} />}

        {prop.order === "S1" &&
          <Tooltip formatter={value => [`${value} ล้านบาท`, "จำนวน"]} />}

        {prop.order === "S2" &&
          <Tooltip formatter={value => [`${value} ล้านบาท`, "จำนวน"]} />}

        {prop.order === "S3" &&
          <Tooltip formatter={value => [`${value} ล้านบาท`, "จำนวน"]} />}

        <Legend />

        {prop.order === "R1" &&
          <Bar
            name="จำนวน (เรื่อง)"
            dataKey="zcount"
            fill={randomColor()}
            barSize={45}
            radius={[8, 8, 0, 0]}
            label={{ position: "top" }}
          />}

        {prop.order === "R2" &&
          <React.Fragment>
            <Bar
              name="Q1"
              dataKey="q1"
              fill="#193591ff"
              barSize={45}
              radius={[8, 8, 0, 0]}
              label={{ position: "top" }}
            />
            <Bar
              name="Q2"
              dataKey="q2"
              fill="#1ca70a"
              barSize={45}
              radius={[8, 8, 0, 0]}
              label={{ position: "top" }}
            />
            <Bar
              name="Q3"
              dataKey="q3"
              fill="#0b3507ff"
              barSize={45}
              radius={[8, 8, 0, 0]}
              label={{ position: "top" }}
            />
            <Bar
              name="Q4"
              dataKey="q4"
              fill="#1691e2ff"
              barSize={45}
              radius={[8, 8, 0, 0]}
              label={{ position: "top" }}
            />
            <Bar
              name="ไม่ระบุ"
              dataKey="qn_a"
              fill="#124be9ff"
              barSize={45}
              radius={[8, 8, 0, 0]}
              label={{ position: "top" }}
            />
          </React.Fragment>}

        {prop.order === "R3" &&
          <Bar
            name="ร้อยละ Been Research"
            dataKey="zcount"
            fill={randomColor()}
            barSize={45}
            radius={[8, 8, 0, 0]}
            label={{
              position: "top",
              formatter: value => `${value}%`
            }}
          />}

        {prop.order === "R4" &&
          <Bar
            name="ร้อยละ Q1"
            dataKey="zcount"
            fill={randomColor()}
            barSize={45}
            radius={[8, 8, 0, 0]}
            label={{
              position: "top",
              formatter: value => `${value}%`
            }}
          />}

        {prop.order === "R5" &&
          <Bar
            name="จำนวนผลงานวิจัยที่เป็นต้นแบบหรือถูกนำไปใช้ประโยชน์ในเชิงพาณิชย์"
            dataKey="zcount"
            fill={randomColor()}
            barSize={45}
            radius={[8, 8, 0, 0]}
            label={{ position: "top" }}
          />}

        {prop.order === "I1" &&
          <Bar
            name="ร้อยละ Q1 ของนักศึกษา"
            dataKey="zcount"
            fill={randomColor()}
            barSize={45}
            radius={[8, 8, 0, 0]}
            label={{
              position: "top",
              formatter: value => `${value}%`
            }}
          />}

        {prop.order === "I2" &&
          <Bar
            name="ร้อยละของนักศึกษาที่เรียนจบตามกำหนดเวลา"
            dataKey="zcount"
            fill={randomColor()}
            barSize={45}
            radius={[8, 8, 0, 0]}
            label={{
              position: "top",
              formatter: value => `${value}%`
            }}
          />}

        {prop.order === "S1" &&
          <Bar
            name="ทุนวิจัย"
            dataKey="zcount"
            fill={randomColor()}
            barSize={45}
            radius={[8, 8, 0, 0]}
            label={{ position: "top" }}
          />}

        {prop.order === "S2" &&
          <Bar
            name="รายได้นอกเหนือจากทุนวิจัย"
            dataKey="zcount"
            fill={randomColor()}
            barSize={45}
            radius={[8, 8, 0, 0]}
            label={{ position: "top" }}
          />}

        {prop.order === "S3" &&
          <Bar
            name="ทุนวิจัยบริษัทยา"
            dataKey="zcount"
            fill={randomColor()}
            barSize={45}
            radius={[8, 8, 0, 0]}
            label={{ position: "top" }}
          />}
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default Barchart;
